// extracted by mini-css-extract-plugin
export default {"paymentRefs":"PaymentReferenceNumbers_paymentRefs__sesBS","cardBody":"PaymentReferenceNumbers_cardBody__67jrP layout_cardBody__lMWLE zb-card-body"};